export const organizationConfig = {
  store: {
    key: 'organization',
  },
};
